import { AppBox, AppText } from "../../../../../commons/components";
export default function MatchStatisticDeleteInprogress() {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>Deleting Statistics In Progress</AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
